import { render, staticRenderFns } from "./barraizquierda.vue?vue&type=template&id=680c56b1&scoped=true&"
import script from "./barraizquierda.vue?vue&type=script&lang=ts&"
export * from "./barraizquierda.vue?vue&type=script&lang=ts&"
import style0 from "./barraizquierda.vue?vue&type=style&index=0&id=680c56b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c56b1",
  null
  
)

export default component.exports